export const getIsUrlAbsolute = (url: string) => url.indexOf('://') > 0 || url.indexOf('//') === 0;
